export default __webpack_public_path__ + "src/assets/icn-arrow-purple.287dbbf867bf3523e9f98a59e25bf877.svg";